import { PayloadAction } from '@reduxjs/toolkit';
import { RegistrationStep, IUpdateRegStepsOptions, RegFieldsEnum } from '@/types/registration.types';
import {
  sortRegistrationSteps,
  getRegistrationQuestionsFromRegistrationSteps,
  sortWorkingEventRegistrationQuestions,
} from '@/utils/registration/registration';
import { ProjectStateReducerCreator } from '../types';

const updateRegistrationStepsReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer(
    (state, action: PayloadAction<{ steps: RegistrationStep[]; options?: IUpdateRegStepsOptions }>) => {
      if (state.workingProject) {
        const updatedSteps = action.payload.steps;
        const options = action.payload?.options;

        const registrationSteps = sortRegistrationSteps(updatedSteps);
        const registrationQuestions = getRegistrationQuestionsFromRegistrationSteps(registrationSteps);

        const requiredRegistrationQuestions = () => {
          // set required questions to email only if makeNameOptional is true
          // Note: if the event has leaderboard or breakout sessions then first/last are required for those features and this will be overwritten
          // it will be overwritten in `registration-required-fields.ts` -> `useSetRequiredField` -> `dispatch(updateRequiredQuestions(updatedReqQuestions));`
          if (options?.makeNameOptional) {
            return [RegFieldsEnum.email];
          }
          return options?.requiredQuestions || state.workingProject?.required_registration_questions || null;
        };

        // sort state.workingEvent.registration_questions
        const updatedRegistrationQnOrder = sortWorkingEventRegistrationQuestions({
          registrationSteps,
          registrationQuestions: registrationQuestions,
          registrationQuestionsToAppend: options?.registrationQuestionsToAppend,
        });

        // remove duplicates
        // the order does matter, however the previous sort should have already sorted the questions
        // so any duplicates should be next to each other
        const updatedRegistrationQnOrderNoDups = Array.from(
          new Map(updatedRegistrationQnOrder.map((q) => [q.registration_question, q])).values()
        );

        state.workingProject.registration_steps = registrationSteps;
        state.workingProject.required_registration_questions = requiredRegistrationQuestions();
        state.workingProject.registration_questions = updatedRegistrationQnOrderNoDups;
      }
    }
  );
};

export default updateRegistrationStepsReducer;
